var map = {
	"./10C.png": 137,
	"./10D.png": 138,
	"./10H.png": 139,
	"./10S.png": 140,
	"./2C.png": 141,
	"./2D.png": 142,
	"./2H.png": 143,
	"./2S.png": 144,
	"./3C.png": 145,
	"./3D.png": 146,
	"./3H.png": 147,
	"./3S.png": 148,
	"./4C.png": 149,
	"./4D.png": 150,
	"./4H.png": 151,
	"./4S.png": 152,
	"./5C.png": 153,
	"./5D.png": 154,
	"./5H.png": 155,
	"./5S.png": 156,
	"./6C.png": 157,
	"./6D.png": 158,
	"./6H.png": 159,
	"./6S.png": 160,
	"./7C.png": 161,
	"./7D.png": 162,
	"./7H.png": 163,
	"./7S.png": 164,
	"./8C.png": 165,
	"./8D.png": 166,
	"./8H.png": 167,
	"./8S.png": 168,
	"./9C.png": 169,
	"./9D.png": 170,
	"./9H.png": 171,
	"./9S.png": 172,
	"./AC.png": 173,
	"./AD.png": 174,
	"./AH.png": 175,
	"./AS.png": 176,
	"./CardBack.png": 68,
	"./JC.png": 177,
	"./JD.png": 178,
	"./JH.png": 179,
	"./JS.png": 180,
	"./Joker BlackBlack.png": 181,
	"./Joker RedRed.png": 182,
	"./KC.png": 183,
	"./KD.png": 184,
	"./KH.png": 185,
	"./KS.png": 186,
	"./QC.png": 187,
	"./QD.png": 188,
	"./QH.png": 189,
	"./QS.png": 190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;